<template>
  <div class="component-part" v-if="init">
    <Finish :data="writingData" v-if="writingData.is_submitted" />
    <div class="component-form" v-else>
      <div class="page-content">
        <h1 class="h1 color-black">Schedule An Appointment</h1>
        <p class="text1 bold color-red-default">Part 2 Drafting, Editing & Revision - 15 mins/person (English), 20 mins/person (Chinese)</p>
        <p class="text1 color-gray-2 mt-30">
          Once you start writing your first draft, you can sign up for Appointment 2. The instructional language of Appointment 2 will be either English or
          Chinese.
        </p>
        <div class="times-select-wrap" v-if="timeOptions.length">
          <CheckboxSlot
            class="radio-item"
            :value="form.option_time === item.option_time"
            @input="form.option_time = item.option_time"
            v-for="item in timeOptions"
            :key="item.option_time"
          >
            <div class="time-wrap">
              <span class="text1 color-gray-2">{{ item.option_time }}</span>
              <div class="lang" :class="{ cn: item.lang === 'Chinese', en: item.lang !== 'Chinese' }"></div>
            </div>
          </CheckboxSlot>
        </div>
        <p class="h2 color-red-default bold mt-10" v-else>This part is fully booked，no vacant seat</p>
        <p class="text1 bold color-gray-1 mt-20">Sign-up Page</p>
        <p class="text1 bold color-gray-1 mt-">Your paper title</p>
        <TextareaPrototype v-model="form.title" class="textarea-wrap mt-10" :counter="false" placeholder="" />
        <p class="text1 bold mt-20 color-gray-1">Tell the tutor about your writing progress</p>
        <div class="progress-wrap mt-20">
          <RadioSlot class="radio-item" :value="form.progress === item" @input="form.progress = item" v-for="item in progressOptions" :key="item">
            <p class="text1 color-gray-2">{{ item }}</p>
          </RadioSlot>
        </div>
        <p class="text1 color-gray-1 bold mt-30">Briefly note questions/concerns in a list here (no more than 3)</p>
        <TextareaPrototype v-model="form.questions" class="textarea-wrap mt-10" :counter="false" placeholder="" />
        <p class="text1 bold color-gray-1 mt-20">Upload a complete outline as much of the paper as possible (Optional)</p>
        <FileUploader v-model="form.outline" class="uploader-wrap mt-10" text="Upload your outline" loadText="loading..." />
        <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
      </div>
    </div>
  </div>
</template>
<script>
import Part1 from '../Part1';
export default {
  name: 'Part2',
  extends: Part1,
  data: () => ({
    part: 2
  }),
  methods: {
    checkOutline() {
      let ret = true;
      if (!this.form.outline?.url) {
        ret = false;
      }
      return true;
    }
  }
};
</script>
